<template>
  <div>
    <el-dialog
      center
      :width="width"
      title="适龄提示"
      :visible.sync="warnShow"
      append-to-body
      @close="close"
    >
      <div class="warn-info">
        <p>
          1.本游戏是一款角色扮演类游戏，适用于满16周岁及以上用户，建议未成年人在家长监护下使用游戏产品。
        </p>
        <p>
          2.本游戏通过游戏环境内的交互，打怪通关等玩法推进剧情。游戏中有基于文字的陌生人社交系统
        </p>
        <p>
          3.本游戏采取用户实名认证系统，未满18周岁的用户不能付费，不可进行游戏。
        </p>
        <p>
          4.本游戏以架空世界为主题，游戏有策略的搭配玩法，需要玩家自行搭配不同的装备互相配合和切磋，有助于培养玩家思维逻辑能力。
        </p>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  props: {
    width: {
      type: String,
    },
  },
  data() {
    return {
      warnShow: false,
    };
  },
  methods: {
    close() {
      this.$emit("warningClose", false);
    },
  },
};
</script>

<style></style>
